import { MCO_PLAN_NAMES } from "./mcoAreaInputs.js";

const ALL_MCO_PLAN_NAMES = Object.values(MCO_PLAN_NAMES).flat();

/** True for any of the 67/68/69 MCO plan name variants. */
export function isMcoPlan(plan) {
  return ALL_MCO_PLAN_NAMES.includes(plan?.insurance_plan_name);
}

/**
 * Plan name → 67/68/69. dbo.InsurancePlan has no insurance_plan_code column, so rows
 * loaded back from the DB only carry the name.
 */
export function mcoPlanCodeFromName(name) {
  return Object.keys(MCO_PLAN_NAMES).find((code) => MCO_PLAN_NAMES[code].includes(name)) || null;
}
